module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__third-4fcbc4aad2428b2b8ce911dfe4197d6c.png";